var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903",
    transform: "translate(7300.345 -10530.654)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-7300.345 10530.654)",
    fill: "#fceb00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-7298.345 10532.654)",
    fill: "#fcca00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M12.145,6.681H8.768L7.741,3.618a.372.372,0,0,0-.7,0L6.017,6.681h-3.4a.368.368,0,0,0-.367.367.27.27,0,0,0,.007.062.353.353,0,0,0,.154.259L5.186,9.326l-1.065,3.1a.368.368,0,0,0,.126.413.355.355,0,0,0,.207.09.45.45,0,0,0,.23-.083l2.709-1.931L10.1,12.843a.43.43,0,0,0,.23.083.33.33,0,0,0,.2-.09.364.364,0,0,0,.126-.413L9.6,9.326l2.753-1.974.067-.057a.351.351,0,0,0-.271-.613Z",
    transform: "translate(-7297.336 10532.539)",
    fill: "#fceb00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.61a376fe4e4efd6badce84f3377cb11f.svg";
export { ForwardRef as ReactComponent };